import React from 'react';
import { TableCell, TableRow,Checkbox} from '@mui/material';
import {TextField} from '@mui/material';
import styled from 'styled-components';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const ButtonWrapper = styled.div`
  display: flex;
`
const ConsumableCatEdit = ({k,row, editFormData, handleCancelClick, consumcat,
   page, rowsPerPage, onChangeEditConsumMaster, SubmitButton, assetmaster}) =>{
    return( <>
        <TableRow key={k} name={row.Category}>
           <TableCell component="th" scope="row">
           {(page)*(rowsPerPage)+k+1}
           </TableCell>
           
           <TableCell  align="left">
            <TextField
                  id="outlined-basic"
                  size='small'
                  type="text"
                  name= "consumable"
                  onChange={(event, newValue) => onChangeEditConsumMaster(event, newValue)}
                  label="Consumable"
                  value={editFormData.consumable}
                  variant="outlined"
                  sx={{backgroundColor:"white", width:"300px", height:"40px"}}
                />         
          </TableCell>

          <TableCell  align="left">
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              size='small'
              value={editFormData?.consumcategory}
              onChange={(event, newValue) => onChangeEditConsumMaster(event, newValue, "consumcategory" , row.id)}
              options={ Object.values(consumcat)?.map(x => x.name)}
              sx={{backgroundColor:"white", width:"200px",  marginRight:"20px",height:"40px"}}
              renderInput={(params) => <TextField {...params} label={"Select Consumable Category"} />}
            />
          </TableCell>

          <TableCell  align="left">
            <Autocomplete
              multiple
              id="checkboxes-tags-demo"
              onChange={(event, newValue) => onChangeEditConsumMaster(event, newValue, "asset" )}
              size="small"
              value={editFormData?.asset}
              options={(assetmaster && editFormData?.consumcategory?.length)? !editFormData?.asset.includes("Not Applicable")? ["Not Applicable"].concat(Object.values(assetmaster).map(x => x.Asset.map(y => y.Name)).flat(3)):["Not Applicable"]:[]}
              disableCloseOnSelect
              getOptionLabel={(option) => option}
              renderOption={(props, option, { selected }) => (
                <li {...props} style={{ fontSize: '2 rem' }}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 0, marginLeft:-8 }}
                    checked={selected}
                  />
                  {option}
                </li>
              )}
              sx={{ width: 250}}
              renderInput={(params) => (
                <TextField {...params} label="Select Asset" sx={{background:"white", width:"100%"}} />
              )}
            />
          </TableCell>          

          <TableCell align="left">
            <ButtonWrapper>
              <SubmitButton type="submit">Save</SubmitButton>
              <SubmitButton type="button" onClick={(e)=>handleCancelClick(e,k)}>Cancel</SubmitButton>
            </ButtonWrapper>                              
            </TableCell>
          </TableRow>     
        </>         
    )
}

export default ConsumableCatEdit;